import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { toggleLoading } from "../LoadingSlice";
import { toast } from "react-toastify";
 
export interface LicenceData {
    company_id: string;
    warehouse_name: string;
    address_line1: string;
    address_line2: string;
    city: string;
    district_id: number;
    state_id: number;
    country_id: number;
    pin_code: string;
    first_name: string;
    last_name: string;
    email: string;
    contact_number: string;
    package_id: number
    final_amount: number;
    payment_method: string;
    minimum_amount: string;
    payment_term: number;
    coupon_code: string;
    payment_due_date: string;
    transaction_id: string;
    payment_mode: string;
    bank_name: string;
    cheque_no: string;
    po_no: string;
    upload_po: string;
    remark: string;
    transaction_date: string;
    advanced_amount: number;
    due_amount: number;
    created_at: string;
    status: string;
    updated_at: string;
    vendor_id:string;
    created_by:any;
    company_type: string;
    warehouse_timezone: string;
    company_name: string;
}

interface LicenceState {
    licence: {
        load: boolean;
        data: Array<LicenceData>;
        errors: Array<LicenceData>;
    };
    licenceData?: LicenceData;
    editLicence: {
        load: boolean;
    };
}
const initialState = {
    licence: {
        load: false,
        data: [],
        errors: []
    },
    licenceData: {
        company_id: "",
        warehouse_name: "",
        address_line1: "",
        address_line2: "",
        city: "",
        district_id: 0,
        state_id: 0,
        country_id: 0,
        pin_code: "",
        first_name: "",
        last_name: "",
        email: "",
        contact_number: "",
        package_id: 0,
        final_amount: 0,
        payment_method: "preactivation",
        minimum_amount: "1000",
        payment_term: 0,
        coupon_code: "COU001",
        payment_due_date: "2025-10-05",
        transaction_id: "TRANS001",
        payment_mode: "Online",
        bank_name: "SBI",
        cheque_no: "CHECK001",
        po_no: "PO001",
        upload_po: "File {name: 'MEPS Report (44).pdf', lastModified: 1745559266602, lastModifiedDate: Fri Apr 25 2025 11:04:26 GMT+0530 (India Standard Time), webkitRelativePath: '', size: 2018736, …}",
        remark: "remark",
        transaction_date: "2025-10-05",
        advanced_amount: 1000,
        due_amount: 500,
        created_at: "",
        status: "",
        updated_at: "",
        vendor_id:"",
        created_by: 0,
        company_type: "",
        warehouse_timezone: "",
        company_name: ""
    },
    editLicence: {
        load: false,
    },
} as LicenceState;

export const LicenceSlice = createSlice({
    name: "licence",
    initialState,
    reducers: {
        resetLicenceData: (state: LicenceState) => {
            state.licenceData = initialState.licenceData;
        },
        updateLicenceData: (state: LicenceState, action: { payload: LicenceData }) => {
            state.licenceData = action.payload;
        },
        failLicenceData: (state, action) => {
            state.licence.errors = action.payload.errors;
        },
    },
    extraReducers: (builder: any) => {
        builder
            .addCase(fetchLicenceList.pending, (state: LicenceState) => {
                state.licence.load = true;
            })
            .addCase(fetchLicenceList.fulfilled, (state: LicenceState, action: any) => {
                state.licence.data = action.payload;
                state.licence.load = false;
            })
            .addCase(fetchLicenceList.rejected, (state: LicenceState) => {
                state.licence.load = false;
            })
            .addCase(fetchLicenceDetails.pending, (state: LicenceState) => {
                state.editLicence.load = true;
            })
            .addCase(fetchLicenceDetails.fulfilled, (state: LicenceState, action: any) => {
                state.licenceData = action.payload;
                state.editLicence.load = false;
            })
            .addCase(fetchLicenceDetails.rejected, (state: LicenceState) => {
                state.editLicence.load = false;
            });
    },
});
export const { updateLicenceData, resetLicenceData, failLicenceData } = LicenceSlice.actions;
export default LicenceSlice.reducer;

export const fetchLicenceList = createAsyncThunk(
    "licence/fetchLicenceList",
    async (param: { apiParam: any }, thunkAPI) => {
        try {
            const { data } = await DataServer.get("api/licenseSummary?page="+param.apiParam.page+"&per_page="+param.apiParam.per_page + "&login_user_id=" + param.apiParam.login_user_id + "&search=" + param.apiParam.search);
            return data.data;
        } catch (error) {
        }
    }
);

export const addLicence = createAsyncThunk(
    "licence/addLicence",
    async (param: { apiParam: any, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post(
                "api/generateWarehouseLicense",
                param.apiParam
            );

            thunkAPI.dispatch(toggleLoading());

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                param.navigation("/licence-summary");
            };
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(failLicenceData(error));
            thunkAPI.dispatch(toggleLoading());
            return error;
        }
    }
);

export const fetchLicenceDetails = createAsyncThunk(
    "LicenceDetails/fetchLicenceDetails",
    async (param: { apiParam : {license_pin : any, login_user_id: any} }, thunkAPI) => {
      try {      
        const { data } = await DataServer.post("api/viewLicenseDetails", {
          license_pin : param.apiParam.license_pin,
          login_user_id : param.apiParam.login_user_id
        });
  
        return data.data;
  
      } catch (error) {
        return(error);
      }
    }
  );

  export const renewLicence = createAsyncThunk(
    "licence/renewLicence",
    async (param: { apiParam: any, navigation: any }, thunkAPI) => {
        try {
            thunkAPI.dispatch(toggleLoading());
            const { data } = await DataServer.post("api/renewLicense", {
                license_pin: param?.apiParam?.license_pin,
                login_user_id: param?.apiParam?.login_user_id,
                package_id: param?.apiParam?.package_id,
                license_status: param?.apiParam?.license_status,
            });

            thunkAPI.dispatch(toggleLoading());

            toast.success(data.message,{theme: "colored", onClose: () => {handleonConfirm();}});

            const handleonConfirm = () => {
                param.navigation("/licence-summary");
            };
            return data.data;
        } catch (error) {
            thunkAPI.dispatch(failLicenceData(error));
            thunkAPI.dispatch(toggleLoading());
            return error;
        }
    }
);
